module.exports = __webpack_public_path__ + "Poppins-Regular.e212f84086965da44a6c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/assets/fonts/Poppins-Regular.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Regular.ttf
// module chunks = styles